module.exports = __webpack_public_path__ + "img/data_moun_ld.450c6dc6.png";